module.exports = __webpack_public_path__ + "media/images/lb/021-e64e8b555f50a35acc3d2d4f67b67fdf.svg";